import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { Modal } from "@/components/common/Modal";
import { contactsService } from "@/api/services/contacts.service";
import { COMPANY_TYPE_VALUES, mapCompanyTypeKeyToLabel, TIER_OPTIONS, } from "@/constants/contactConstants";
import styles from "./ContactsFilterModal.module.css";
const ghlContactTypes = [
    { label: "Subcontractor", value: "subcontractor" },
    { label: "Architect / Designer", value: "architect_designer" },
    { label: "Supplier / Vendor", value: "supplier" },
    { label: "Surveyor", value: "surveyor" },
    { label: "Client", value: "client" },
    { label: "Lead", value: "lead" },
    { label: "Partner", value: "partner" },
];
export const ContactsFilterModal = ({ isOpen, onClose, filterType, currentValue, onApply, }) => {
    const [options, setOptions] = useState(null);
    const [loading, setLoading] = useState(true);
    const [selectedValue, setSelectedValue] = useState(currentValue);
    useEffect(() => {
        if (isOpen) {
            setSelectedValue(currentValue);
            if (filterType === "contactType") {
                fetchOptions();
            }
        }
    }, [isOpen, currentValue, filterType]);
    const fetchOptions = async () => {
        try {
            setLoading(true);
            const response = await contactsService.getFilterOptions();
            setOptions(response.data);
        }
        catch (err) {
            console.error("Failed to fetch filter options:", err);
        }
        finally {
            setLoading(false);
        }
    };
    const handleApply = () => {
        onApply(selectedValue);
        onClose();
    };
    const handleClear = () => {
        setSelectedValue("");
        onApply("");
        onClose();
    };
    const getTitle = () => {
        if (filterType === "companyType")
            return "Filter by Company Type";
        if (filterType === "contactType")
            return "Filter by Contact Type";
        return "Filter by Tier";
    };
    const getOptions = () => {
        if (filterType === "companyType") {
            return COMPANY_TYPE_VALUES;
        }
        if (filterType === "contactType") {
            return ghlContactTypes.map((type) => type.value);
        }
        if (filterType === "tier") {
            return TIER_OPTIONS.map((opt) => opt.value);
        }
        if (!options)
            return [];
        return options.contactTypes;
    };
    const getDisplayLabel = (value) => {
        if (filterType === "tier") {
            const tierOpt = TIER_OPTIONS.find((opt) => opt.value === value);
            return tierOpt ? tierOpt.label : value;
        }
        const ghlType = ghlContactTypes.find((type) => type.value === value);
        if (ghlType) {
            return ghlType.label;
        }
        if (filterType === "companyType") {
            return mapCompanyTypeKeyToLabel(value) || value;
        }
        return value
            .split("_")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(" ");
    };
    const isLoading = filterType === "contactType" && loading;
    return (_jsx(Modal, { isOpen: isOpen, onClose: onClose, title: getTitle(), children: _jsx("div", { className: styles.container, children: isLoading ? (_jsx("div", { className: styles.loading, children: "Loading options..." })) : (_jsxs(_Fragment, { children: [_jsxs("div", { className: styles.selectWrapper, children: [_jsx("label", { className: styles.label, children: filterType === "companyType"
                                    ? "Company Type"
                                    : filterType === "contactType"
                                        ? "Contact Type"
                                        : "Tier" }), _jsxs("select", { className: styles.select, value: selectedValue, onChange: (e) => setSelectedValue(e.target.value), children: [_jsx("option", { value: "", children: "Select an option..." }), getOptions().map((option) => (_jsx("option", { value: option, children: getDisplayLabel(option) }, option)))] })] }), _jsxs("div", { className: styles.actions, children: [_jsx("button", { type: "button", className: styles.clearBtn, onClick: handleClear, children: "Clear Filter" }), _jsx("button", { type: "button", className: styles.applyBtn, onClick: handleApply, disabled: !selectedValue, children: "Apply Filter" })] })] })) }) }));
};
